import * as React from 'react';
import { Icon } from '../icon';
import clsx from 'clsx';

interface IconBadgeProps {
	size: 'small' | 'medium' | 'large';
	icon: string;
	iconColor: string;
	bgColor: string;
}

export const IconBadge: React.FC<IconBadgeProps> = ({
	size,
	icon,
	iconColor,
	bgColor,
}) => {
	return (
		<span
			className={clsx(
				'flex items-center justify-center rounded-full flex-shrink-0',
				{ 'size-12': size === 'large' },
				{ 'size-10': size === 'medium' },
				{ 'size-8': size === 'small' }
			)}
			style={{ backgroundColor: bgColor }}
		>
			<Icon
				src={icon}
				className={clsx(
					`!text-[${iconColor}]`,
					{ '!size-6': size === 'large' },
					{ '!size-5': size === 'medium' },
					{ '!size-4': size === 'small' }
				)}
			/>
		</span>
	);
};
